import React, { SyntheticEvent, useCallback, useMemo } from 'react';

import { RadioGroup } from '@atlaskit/radio';

import { useIntl } from 'src/hooks/intl';
import { LoadFileMode } from 'src/redux/diff-settings';

import { useDiffSettingsForm } from './diff-settings-form';
import messages from './i18n';

type Props = {
  isDisabled: boolean;
};

export const SingleFileModeField = React.memo((props: Props) => {
  const intl = useIntl();
  const [formState, setFormState] = useDiffSettingsForm();

  const handleRadioGroupChange = useCallback(
    (event: SyntheticEvent<HTMLInputElement>) => {
      const isSingleFileModeEnabled =
        event.currentTarget.value === LoadFileMode.SingleFileMode;
      setFormState(state => ({
        ...state,
        globalIsSingleFileModeEnabled: isSingleFileModeEnabled,
      }));
    },
    [setFormState]
  );

  const fileLoadOptions = useMemo(
    () => [
      {
        label: intl.formatMessage(messages.allFileModeRadioButtonLabel),
        value: LoadFileMode.AllFilesMode,
      },
      {
        label: intl.formatMessage(messages.singleFileModeRadioButtonLabel),
        value: LoadFileMode.SingleFileMode,
      },
    ],
    [intl]
  );

  return (
    <RadioGroup
      isDisabled={props.isDisabled}
      options={fileLoadOptions}
      onChange={handleRadioGroupChange}
      name="isSingleFileModeEnabled"
      value={
        fileLoadOptions.find(
          option =>
            (formState.globalIsSingleFileModeEnabled &&
              option.value === LoadFileMode.SingleFileMode) ||
            (!formState.globalIsSingleFileModeEnabled &&
              option.value === LoadFileMode.AllFilesMode)
        )?.value
      }
    />
  );
});
